import React from 'react'
import { BlackButtonLink } from '../Buttons'
import { HOME_OFFERINGS } from '../../Config/config'
import { SectionHeading } from '../Headers'
import { OfferCon } from './styles'
import { Img } from '../Image/Img'
// import Image2 from '../Image2'

export const HomeOfferings: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <OfferCon>
      {HOME_OFFERINGS.map((offer) => (
        <div className="itemCon" key={offer.title}>
          {offer.title && <SectionHeading headingText={offer.title} lowMargin />}
          <Img src={offer.imageUrl} alt={`Home offer image ${offer.title}`} />
          {offer.subText && <div className="subText">{offer.subText}</div>}
          {offer.buttonText && (
            <BlackButtonLink
              href={offer.link}
              analytics={{
                event: 'home_offerings_click',
                params: {
                  title: offer.title,
                  section: 'home_offerings',
                  btn_text: offer.buttonText,
                  link: offer.link,
                },
              }}
            >
              {offer.buttonText}
            </BlackButtonLink>
          )}
        </div>
      ))}
    </OfferCon>
  )
}
